import ConsultationSummary from './ConsultationSummary';

export default ConsultationSummary;
